module.exports = __webpack_public_path__ + "img/LogoXsite.397d54c6.png";